import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, Events, AlertController } from 'ionic-angular';
import { EventCreatePage } from '../event-create/event-create';
import { EventsProvider } from '../../providers/events/events.provider';
import { CategoriesProvider } from '../../providers/categories/categories.provider';
import { EventPage } from '../event/event';
import { AuthProvider } from '../../providers/auth/auth.provider';
import { LoginModalPage } from '../login-modal/login-modal';
import { GeocodingProvider } from '../../providers/geocoding/geocoding.provider';
/**
 * Generated class for the ExplorePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-events',
  templateUrl: 'events.html',
})
export class EventsPage {
  search: any = "";
  events_list: any = [];
  categories: any = [];
  cardSelectorModal: any;
  want_to_create_event = false;
  position : any = null;
  position_filter : any = null;

  constructor(
    public navCtrl: NavController, 
    public modalCtrl: ModalController, 
    public navParams: NavParams,
    private eventsProvider: EventsProvider,
    private events: Events,
    private authProvider: AuthProvider,
    private alertCtrl: AlertController,
    private geocodingProvider: GeocodingProvider,
    private categoriesProvider: CategoriesProvider
  ) {  

    this.cardSelectorModal = this.modalCtrl.create(LoginModalPage,{});


    this.events.subscribe('user:login',() => {
      this.cardSelectorModal.dismiss();
      if(this.want_to_create_event){
        setTimeout(() => {
          this.goToEventCreate();
        },1000);
      }
    });
    this.events.subscribe('user:logout',() => {

    });
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ExplorePage');
  }
  ionViewDidEnter() {
    this.refresh();
  }
  
  setPosition(){
    let alert = this.alertCtrl.create();
    alert.setTitle('Modifier ma localisation');
    let items = ["county","state","country"];
    let checked;

    for(let item of items){
      checked = false;
      if(item == this.position_filter)
        checked = true;

      alert.addInput({
        type: 'radio',
        label: this.position[item],
        value: item,
        checked: checked
      });
    }

    alert.addButton('Annuler');
    alert.addButton({
      text: 'OK',
      handler: data => {
        console.log("setPosition result", data);
        this.position_filter = data;
        this.loadEventsByPosition();
      }
    });
    alert.present();
  }

  async refresh(){
    await this.refresh_position();
    console.log("this.position",this.position);
    let event_list = await this.eventsProvider.getEvents();
    if(this.position == null){
     this.events_list = event_list;
      console.log("this.events_list",this.events_list)
    }

    this.categories = await this.categoriesProvider.getCategories();
    // console.log("this.categories",this.categories)
  }

  async loadEventsByPosition(){
    this.events_list = await this.eventsProvider.getEventsByPosition(this.position_filter,this.position);
  }
  
  async refresh_position() {
    let position = await this.geocodingProvider.getPosition();
    if(position.county)
      this.position_filter = 'county';
    else
      this.position_filter = 'state';
    this.position = position;
    this.loadEventsByPosition();
  }

  goToEvent(event){
    this.navCtrl.push(EventPage, {event:event});
  }

  goToEventCreate(){
    if(this.authProvider.isConnected()){
      let modal = this.modalCtrl.create(EventCreatePage,{});
      modal.present();
      modal.onDidDismiss(async data => {
        // console.log("data",data);
        this.refresh();
      });
    }
    else {
      // console.log('checkLogin offline');
      this.want_to_create_event = true;
      this.cardSelectorModal.onDidDismiss(data => {
        // console.log("data",data);
        this.want_to_create_event = null;
        if(data != null){
        }
      });
      this.cardSelectorModal.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/events/events.ts